import React, { Component } from 'react'
import AppMonitoring from 'utilities/monitoring'
import DefaultErrorBoundary from './views/defaultBoundary'
import ContentErrorBoundary from './views/contentBoundary'
import DisplayStackTrace from './views/displayStackTrace'

import type { ErrorComponentInterface } from './views/types'
import type { ErrorStack, Props, State } from './types'

export { DisplayStackTrace, ContentErrorBoundary }
export type { ErrorComponentInterface }

class ErrorBoundary extends Component<Props, State> {
  constructor (props: any) {
    super(props)
    this.state = {
      hasError: false,
      errors: null
    }
  }

  // https://reactjs.org/docs/error-boundaries.html
  componentDidCatch (error: Error, info: ErrorStack) {
    const prod = process.env.NODE_ENV === 'production'

    if (this.props.devOnly && prod) {
      // We don't want to render this boundary in production
// @ts-expect-error - TS2769 - No overload matches this call.
      throw new Error(error)
    }

    this.setState({
      hasError: true,
      errors: {
        message: error.message,
        name: error.name,
        componentStack: info.componentStack
      }
    })

    if (prod) {
      AppMonitoring.noticeError(error, { extra: info })
    }
  }

  render () {
    const { hasError, errors } = this.state
// @ts-expect-error - TS2339 - Property 'component' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
    const { children, classes, component } = this.props

    if (hasError) {
      return React.createElement(component || DefaultErrorBoundary, { classes, errors })
    }

    return children || null // To prevent "Nothing was returned from render" error
  }
}

export default ErrorBoundary
